import React from 'react'
import { TaskService } from '@duck/api-definitions'
import { Button } from '@duck/ui'
import { useTar } from '@/modules'
import { WysiwygEditor } from '@/components/WysiwygEditor/WysiwygEditor'
import { TaskFormField } from './TaskFormField'

interface BodySectionProps {
  formData: Partial<TaskService.Task>
  onChange: (field: keyof TaskService.Task, value: string | number | string[] | TaskService.TaskWeaponsOfChoiceEnum[] | boolean | undefined) => void
  isSaving?: boolean
  fieldErrors?: Record<string, string>
}

export const BodySection: React.FC<BodySectionProps> = ({
  formData,
  onChange,
  isSaving = false,
  fieldErrors = {},
}) => {
  const { t } = useTar()

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-foreground border-b border-border pb-2">
          {t('common.body')}
        </h3>
        <TaskFormField field="body" type="markdown" required formData={formData} onChange={onChange} fieldErrors={fieldErrors} />
      </div>

      {/* Solution Placeholder */}
      <div className="space-y-4">
        <div className="space-y-2">
          <div className="flex items-center justify-between gap-4">
            <label className="block text-sm font-medium text-foreground">
              {t('tasks.solutionPlaceholder')}
            </label>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onChange('solutionPlaceholder', '')}
              disabled={isSaving}
            >
              {t('tasks.clearForDefaultPlaceholder')}
            </Button>
          </div>
          <WysiwygEditor
            content={formData.solutionPlaceholder ?? ''}
            onChange={(content) => onChange('solutionPlaceholder', content)}
            placeholder={t('common.enterValue', { value: t('tasks.solutionPlaceholder').toLowerCase() })}
            className="max-h-[240px] min-h-[180px] border border-border rounded-md bg-card"
          />
          {fieldErrors.solutionPlaceholder && (
            <p className="text-sm text-error mt-1">{fieldErrors.solutionPlaceholder}</p>
          )}
        </div>
      </div>
    </div>
  )
}
